import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/public/thumbAvtar.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/lp-frontend/src/app/[lang]/testimonial/TestimonialGrid.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/lp-frontend/src/components/Academy.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Layout","ContentContainer","Stack","Heading","TP"] */ "/root/lp-frontend/src/components/molecules/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/lp-frontend/src/components/NoResult.jsx");
